import React from "react";
import RangeSlider from "../../../elements/track-range-slider";
import OptionToggle from "../../../elements/option-toggle";

const Slider = props => {
  return props.options ? <OptionToggle {...props} /> : <RangeSlider {...props} />;
};

export default Slider;
